module.exports = __webpack_public_path__ + "img/img6.f0271e78.svg";